module.exports = __webpack_public_path__ + "static/media/dca.11c40286.png";